module.exports = __webpack_public_path__ + "img/01_Datos - ICONO.9f4457ea.png";